import { render, staticRenderFns } from "./PCBasicToast.vue?vue&type=template&id=a9736ec4&scoped=true"
import script from "./PCBasicToast.vue?vue&type=script&lang=js"
export * from "./PCBasicToast.vue?vue&type=script&lang=js"
import style0 from "./PCBasicToast.vue?vue&type=style&index=0&id=a9736ec4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9736ec4",
  null
  
)

export default component.exports